import { render, staticRenderFns } from "./ImageReviewStaffManage.vue?vue&type=template&id=2490e085&scoped=true"
import script from "./ImageReviewStaffManage.vue?vue&type=script&lang=js"
export * from "./ImageReviewStaffManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490e085",
  null
  
)

export default component.exports